import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'minutesToHours',
})
export class MinutesToHoursPipe implements PipeTransform {
  constructor() {}

  transform(minutes: number): number {
    return Math.ceil(minutes / 60);
  }
}
